import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import Seo from "../components/Seo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login", { replace: true }); return; }
    const session_id = m[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        await refresh();
        const role = data?.user?.role;
        const to = (role === "admin" || role === "subadmin") ? "/admin"
          : role === "trainer" ? "/trainer" : "/learner";
        nav(to, { replace: true });
      } catch (e) {
        console.error(e);
        nav("/login", { replace: true });
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <Seo title="Signing In – DriveTerrain" description="Completing sign-in." robots="noindex, nofollow" hrefLangs={false} />
      <div className="text-sm uppercase tracking-widest text-muted-foreground" data-testid="auth-callback">Signing you in…</div>
    </div>
  );
}
